import * as React from 'react';
import c from 'classnames';
import styles from './ButtonSwitch.css';

export const ButtonSwitch = ({ labelText, id, value, onSelect }) => (
  <div 
    id={id} 
    className={styles.button_switch} 
    onClick={() => onSelect()}
  >
    <label className={c(
      styles.switcher,
      { [styles.checked]: value },
    )}>
      <span className={c(styles.slider, styles.round)}/>
      <span className={styles.slider_label}>{labelText}</span>
    </label>
  </div> 
);

export const ButtonMultiSwitch = ({ name, value, options, onSelect, label }) => (

  <div className={styles.button_switch}>
    {options.map(opt =>
      <label className={c(styles.multi_switcher, {[styles.checked]: opt.value === value})} key={opt.value}>
        <input type="radio" name={name} checked={opt.value === value} onChange={() => onSelect(opt.value)}/>
        <div className={styles.checker}></div>   
        {opt.name}
      </label>,
    )}
  </div>
);